import { render, staticRenderFns } from "./LogLegajoDigital.vue?vue&type=template&id=64e80d00"
import script from "./LogLegajoDigital.vue?vue&type=script&lang=js"
export * from "./LogLegajoDigital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports